import settings from "../../../../constants/settings";
import useFetchAndTrace from "../../fetchWithTrace";
import { useCallback } from "react";
import { useCustomAlert } from "../../alerts";

export default function useDownloadTraveler() {
  const customAlert = useCustomAlert();
  const fetchAndTrace = useFetchAndTrace();

  const errorHandler = useCallback(() => {
    customAlert("Failed to download traveler");
  }, [customAlert]);

  return useCallback(
    (boardId: string) => {
      const travelerStickerHandler = async (response: Response) => {
        if (response.ok) {
          const blob = await response.blob();
          const link = document.createElement("a");
          link.download = `FlashPCB-traveler-sticker-${boardId}`;
          const objectUrl = URL.createObjectURL(blob);
          link.href = objectUrl;
          link.click();
          window.open(objectUrl);
        } else {
          throw new Error(
            "Unable to retrieve traveler sticker for purchased board",
          );
        }
      };

      void fetchAndTrace(
        `${settings.api_url}/boards/${boardId}/traveler`,
        travelerStickerHandler,
        errorHandler,
      );
    },
    [fetchAndTrace, errorHandler],
  );
}
